import { render } from "./AllSubmittedApplications.vue?vue&type=template&id=77cf005e&scoped=true"
import script from "./AllSubmittedApplications.vue?vue&type=script&lang=js"
export * from "./AllSubmittedApplications.vue?vue&type=script&lang=js"

import "./AllSubmittedApplications.vue?vue&type=style&index=0&id=77cf005e&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77cf005e"]])

export default __exports__